import { IconButton, Tooltip } from "@mui/material";
import ExcelIcon from '../../assets/excel_icon.png';
import ApiService from '../../utils/fetch';
import PropTypes from 'prop-types';

/**
 * DownloadExcelButton - a reusable Excel download icon button
 * @param {string} endpoint - API endpoint (full URL)
 * @param {object} payload - POST body (filters, etc)
 * @param {object} params - Query params (page, size, download, etc)
 * @param {string} [defaultFilename] - fallback filename
 * @param {string} [tooltip] - tooltip text
 * @param {object} [iconStyle] - style for the icon
 * @param {object} [buttonStyle] - style for the IconButton wrapper
 */
export default function DownloadExcelButton({ endpoint, payload, params, defaultFilename = 'Download.xlsx', tooltip = 'Download Excel', iconStyle, buttonStyle }) {
  const handleDownload = async () => {
    try {
      const response = await ApiService.downloadFile(endpoint, payload, {}, params);
      let filename = defaultFilename;
      const disposition = response.headers && response.headers['content-disposition'];
      if (disposition) {
        let filenameStar = null;
        let filenameNormal = null;
        let matchStar = disposition.match(/filename\*=(?:UTF-8'')?([^;\n]+)/i);
        if (matchStar && matchStar[1]) {
          filenameStar = decodeURIComponent(matchStar[1].replace(/['"]/g, '').trim());
        }
        let matchNormal = disposition.match(/filename="?([^";\n]+)"?/i);
        if (matchNormal && matchNormal[1]) {
          let val = matchNormal[1].trim();
          if (/^=\?UTF-8\?Q\?/i.test(val)) {
            val = val.replace(/^=\?UTF-8\?Q\?/i, '').replace(/\?=$/, '');
            val = val.replace(/_/g, ' ');
            val = val.replace(/=([A-Fa-f0-9]{2})/g, (m, hex) => String.fromCharCode(parseInt(hex, 16)));
          }
          filenameNormal = val;
        }
        if (filenameStar) {
          filename = filenameStar;
        } else if (filenameNormal) {
          filename = filenameNormal;
        }
      }
      const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // Optionally show error to user
      console.error('Download failed', error);
    }
  };

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={handleDownload} size="large" style={buttonStyle}>
        <img src={ExcelIcon} alt="Download Excel" style={{ width: 28, height: 28, ...iconStyle }} />
      </IconButton>
    </Tooltip>
  );
}

DownloadExcelButton.propTypes = {
  endpoint: PropTypes.string.isRequired,
  payload: PropTypes.object,
  params: PropTypes.object,
  defaultFilename: PropTypes.string,
  tooltip: PropTypes.string,
  iconStyle: PropTypes.object,
  buttonStyle: PropTypes.object,
};
